import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { supabase } from "../lib/supabase";
import { useAuth } from "../context/AuthContext";
import { getPostLoginRoute } from "../utils/routeHelpers";

function Login() {
  const navigate = useNavigate();
  const { refreshProfile } = useAuth();

  const [mode, setMode] = useState("phone");
  const [formData, setFormData] = useState({
    phone: "",
    email: "",
    password: "",
  });

  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      let result;

      if (mode === "phone") {
        if (!formData.phone.trim()) {
          throw new Error("Phone number is required.");
        }

        result = await supabase.auth.signInWithPassword({
          phone: formData.phone.trim(),
          password: formData.password,
        });
      } else {
        if (!formData.email.trim()) {
          throw new Error("Email is required.");
        }

        result = await supabase.auth.signInWithPassword({
          email: formData.email.trim(),
          password: formData.password,
        });
      }

      if (result.error) throw result.error;
      if (!result.data.user) throw new Error("Login failed.");

      const profile = await refreshProfile(result.data.user.id);

      navigate(getPostLoginRoute(profile));
    } catch (error) {
      console.error("Login error:", error);
      alert(error.message || "Login failed.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={page}>
      <div style={wrapper} className="auth-page__wrapper">
        <div style={hero} className="auth-page__hero">
          <div style={heroBadge}>Welcome back</div>
          <h1 style={heroTitle} className="auth-page__title">Login to MistriBazaar</h1>
          <p style={heroText} className="auth-page__hero-text">
            Use phone + password by default. Email + password works after email is linked to the auth account.
          </p>
        </div>

        <div style={card} className="auth-page__card">
          <h2 style={{ marginTop: 0 }}>Login</h2>

          <form onSubmit={handleLogin}>
            <label style={label}>Login Method</label>
            <select
              value={mode}
              onChange={(e) => setMode(e.target.value)}
              style={input}
            >
              <option value="phone">Phone + Password</option>
              <option value="email">Email + Password</option>
            </select>

            {mode === "phone" ? (
              <>
                <label style={label}>Phone Number</label>
                <input
                  name="phone"
                  placeholder="+91XXXXXXXXXX"
                  value={formData.phone}
                  onChange={handleChange}
                  required
                  style={input}
                />
              </>
            ) : (
              <>
                <label style={label}>Email</label>
                <input
                  name="email"
                  type="email"
                  placeholder="Enter your email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  style={input}
                />
              </>
            )}

            <label style={label}>Password</label>
            <input
              name="password"
              type="password"
              placeholder="Enter your password"
              value={formData.password}
              onChange={handleChange}
              required
              style={input}
            />

            <button type="submit" disabled={loading} style={button}>
              {loading ? "Logging in..." : "Login"}
            </button>
          </form>

          <div style={{ marginTop: "14px" }}>
            <Link to="/forgot-access" style={link}>
              Forgot password? Use OTP instead
            </Link>
          </div>

          <p style={footerText}>
            New here?{" "}
            <Link to="/signup" style={link}>
              Create your account
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
}

const page = {
  background: "radial-gradient(circle at top, #101010 0%, #000 55%)",
  minHeight: "100vh",
  padding: "40px 20px",
  color: "#fff",
  fontFamily: "Arial, sans-serif",
};

const wrapper = {
  maxWidth: "1100px",
  margin: "0 auto",
  display: "grid",
  gridTemplateColumns: "1.1fr 0.9fr",
  gap: "24px",
  alignItems: "center",
};

const hero = {
  background: "linear-gradient(135deg, #111, #191919)",
  border: "1px solid #222",
  borderRadius: "22px",
  padding: "30px",
};

const heroBadge = {
  display: "inline-block",
  padding: "8px 14px",
  borderRadius: "999px",
  border: "1px solid #2a2a2a",
  background: "#0d0d0d",
  color: "#d1d1d1",
  fontSize: "13px",
  marginBottom: "18px",
};

const heroTitle = { margin: 0, fontSize: "40px" };
const heroText = { marginTop: "14px", color: "#d1d1d1", lineHeight: "1.8" };

const card = {
  background: "#111",
  padding: "26px",
  borderRadius: "20px",
  border: "1px solid #2a2a2a",
  boxShadow: "0 12px 32px rgba(0,0,0,0.22)",
};

const label = {
  display: "block",
  marginBottom: "8px",
  marginTop: "12px",
  color: "#fff",
};

const input = {
  width: "100%",
  padding: "12px 14px",
  marginBottom: "12px",
  borderRadius: "10px",
  border: "1px solid #2a2a2a",
  background: "#0b0b0b",
  color: "#fff",
  boxSizing: "border-box",
};

const button = {
  width: "100%",
  padding: "12px 16px",
  borderRadius: "10px",
  border: "none",
  background: "#fff",
  color: "#000",
  fontWeight: "bold",
  cursor: "pointer",
  marginTop: "10px",
};

const footerText = { color: "#c9c9c9", marginTop: "18px", marginBottom: 0 };
const link = { color: "#fff" };

export default Login;
